// extracted by mini-css-extract-plugin
module.exports = {"postAsideSection":"post-aside-section_postAsideSection__8sF7c"};